import { px, rect, cRect, mPx, CENTER } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_interceptor: Hull = {
  id: 'hull_interceptor',
  name: 'Interceptor',
  drawBody: (ctx, p) => {
    const profile: [number, number][] = [
      [19,1],[20,1],[21,1],[22,1],[23,2],[24,2],[25,2],
      [26,3],[27,3],[28,3],[29,3],[30,4],[31,4],[32,4],
      [33,4],[34,4],[35,4],[36,3],[37,3],[38,3],[39,2],[40,2],[41,2],
    ];
    profile.forEach(([y, hw]) => cRect(ctx, y, hw * 2, 1, p.primary));
    profile.forEach(([y, hw]) => { px(ctx, CENTER - hw, y, p.light); px(ctx, CENTER + hw - 1, y, p.shadow); });
    cRect(ctx, 37, 8, 1, p.shadow); cRect(ctx, 39, 6, 1, p.shadow); cRect(ctx, 41, 4, 1, p.dark);
    // Accent stripe
    cRect(ctx, 24, 2, 12, p.accent);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 27 }, cap: (ctx, p) => { mPx(ctx, 2, 26, p.dark); mPx(ctx, 2, 27, p.dark); cRect(ctx, 30, 4, 1, p.dark); } },
    [SLOT.WING_L]:     { anchor: { x: 26, y: 34 }, cap: (ctx, p) => { rect(ctx, 25, 33, 3, 3, p.shadow); rect(ctx, 25, 33, 3, 1, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 37, y: 34 }, cap: (ctx, p) => { rect(ctx, 36, 33, 3, 3, p.shadow); rect(ctx, 36, 33, 3, 1, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 30, y: 41 }, cap: (ctx, p) => { rect(ctx, 29, 40, 3, 2, p.shadow); px(ctx, 29, 40, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 34, y: 41 }, cap: (ctx, p) => { rect(ctx, 32, 40, 3, 2, p.shadow); px(ctx, 34, 40, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 23 }, base: (ctx, p) => { cRect(ctx, 24, 2, 3, p.metalDark); cRect(ctx, 24, 2, 1, p.metal); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 19 } },
  },
};
